import $ from 'jquery';

// Compatibility shims for legacy jQuery plugins running on jQuery 4.
if (typeof $.trim !== 'function') {
    $.trim = function (value) {
        return value == null ? '' : String(value).trim();
    };
}

if (typeof $.isFunction !== 'function') {
    $.isFunction = function (value) {
        return typeof value === 'function';
    };
}

if (typeof $.isNumeric !== 'function') {
    $.isNumeric = function (value) {
        if (typeof value === 'symbol') {
            return false;
        }

        const normalized = typeof value === 'string' ? value.trim() : value;

        if (normalized === '' || normalized == null) {
            return false;
        }

        return Number.isFinite(Number(normalized));
    };
}
